/**
 * 출처의 짧은 표기.
 *
 * `grant_sources.name` 은 「K-Startup 지원사업 공고」처럼 길어서 카드 한 줄에
 * 넣으면 제목을 밀어낸다. 목록에서는 **어디서 왔는지만** 알면 되므로 기관
 * 이름까지 줄인다. 상세에서는 원래 이름을 그대로 쓴다.
 *
 * 표를 두지 않고 문자열을 자르는 이유: 새 출처가 붙었을 때 표에 없다고
 * 빈칸이 되면 안 된다. 모르는 이름은 그대로 보여주는 편이 안전하다.
 */
export function shortSourceName(name: string): string {
  const first = name.split(/\s+/)[0] ?? name;
  // 「중소벤처기업부 사업공고 RSS」처럼 첫 토큰이 이미 기관명이면 그것으로 충분하다.
  return first.replace(/(지원사업|사업공고|공고)$/, '') || first;
}
